module.exports = __webpack_public_path__ + "static/favicon-858e2efd7ee8c8870c5d766e2e8e1ba9.ico";